export enum PermissionType {
  ALL = 'all',
  ADD = 'add',
  EDIT = 'edit',
  ARCHIVE = 'archive',
  VIEW = 'view',
  EXCEL = 'excel',
  SHOW_MENU = 'showMenu'
}
